const VERSION = "v1";

export function activeAccountId(accounts: ReadonlyArray<{ id: number; isArchived: boolean }>, preferredId: number) {
  return accounts.find((account) => account.id === preferredId && !account.isArchived)?.id
    ?? accounts.find((account) => !account.isArchived)?.id
    ?? 0;
}

export function readPreference(key: string) {
  try { return localStorage.getItem(`${key}:${VERSION}`); } catch { return null; }
}

export function writePreference(key: string, value: string) {
  try { localStorage.setItem(`${key}:${VERSION}`, value); } catch { /* Preferences are optional. */ }
}
